import { combineReducers, configureStore } from "@reduxjs/toolkit";
// eslint-disable-next-line import/no-extraneous-dependencies
import createStore from "react-auth-kit/createStore";
// @ts-expect-error: existing js file
import storage from "redux-persist-indexeddb-storage";
import { createReduxEnhancer } from "@sentry/react";
// import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { sanitiseStateForSentry, redactPII } from "@/utils/sanitiseStateForSentry";
// @ts-expect-error: existing js file
import { formdataSlice } from "./slices/applicationFormSlice";
// @ts-expect-error: existing js file
import { applicationsSlice } from "./slices/applicationsSlice";
// @ts-expect-error: existing js file
import { customerSlice } from "./slices/customerSlice";
// @ts-expect-error: existing js file
import { userSlice } from "./slices/userSlice";
// @ts-expect-error: existing js file
import { usersSlice } from "./slices/usersSlice";
// @ts-expect-error: existing js file
import { organisationSlice } from "./slices/organisationSlice";
// @ts-expect-error: existing js file
import { applicationsAssetSlice } from "./slices/applicationAssetSlice";
// @ts-expect-error: existing js file
import { calculatorSlice } from "./slices/calculatorSlice";
import { templatesSlice } from "./slices/templatesSlice";
import { tenantSlice } from "./slices/tenantSlice";
import { serviceSlice } from "./slices/serviceSlice";
import { invoiceSlice } from "./slices/invoiceSlice";
// @ts-expect-error: existing js file
import { lenderApi } from "./slices/apiSlice";
// import { lenderChunksSlice } from "./slices/lenderChunkSlice";
// @ts-expect-error: existing js file
import { expirationMiddleware } from "./middleware/expirationMiddleware";
import { themeKeyMiddleware } from "./middleware/themeKeyMiddleware";
import { snackbarSlice } from "./slices/snackbarSlice";
import { quoteCalculatorSlice } from "./slices/quoteCalculator";
import { quoteSlice } from "./slices/quoteSlice";
import { lenderCardsSlice } from "./slices/lenderCards";
import { lodgeAISlice } from "./slices/lodgeAISlice";
import authV2Slice from "./slices/authV2Slice";
import { themeSlice } from "./slices/themeSlice";

const sentryReduxEnhancer = createReduxEnhancer({
  stateTransformer: (state) => {
    const sanitised = sanitiseStateForSentry(state as Record<string, unknown>);
    return sanitised;
  },
  actionTransformer: (action) => ({
    ...action,
    payload: action.payload ? redactPII(action.payload) : action.payload,
  }),
});

const persistConfig = {
  key: "root",
  storage: storage("financeableDB"),
  // storage,
  whitelist: ["lenderApi"], // Add the slices you want to persist
  transforms: [
    {
      // @ts-expect-error: existing js file
      in: (state, key) => ({ ...state, timestamp: Date.now() }),
      // @ts-expect-error: existing js file
      out: (state, key) => state,
    },
  ],
};

const rootReducer = combineReducers({
  userDetails: formdataSlice.reducer,
  applications: applicationsSlice.reducer,
  assert: applicationsAssetSlice.reducer,
  user: userSlice.reducer,
  Quotes: quoteSlice.reducer,
  users: usersSlice.reducer,
  customer: customerSlice.reducer,
  organisation: organisationSlice.reducer,
  calculator: calculatorSlice.reducer,
  tenant: tenantSlice.reducer,
  service: serviceSlice.reducer,
  invoice: invoiceSlice.reducer,
  templates: templatesSlice.reducer,
  [lenderApi.reducerPath]: lenderApi.reducer,
  snackbar: snackbarSlice.reducer,
  quoteCalculator: quoteCalculatorSlice.reducer,
  lenderCards: lenderCardsSlice.reducer,
  lodgeAI: lodgeAISlice.reducer,
  authV2: authV2Slice.reducer,
  theme: themeSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const getStore = (isPublicRoute?: boolean) => {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => {
      if (isPublicRoute) {
        // The themeKeyMiddleware is not added to the public routes because there is no logged in information that we can tap into
        // from the state which we can use to determine the theme.
        return getDefaultMiddleware({ serializableCheck: false }).concat();
      }
      return getDefaultMiddleware({ serializableCheck: false }).concat(
        lenderApi.middleware,
        expirationMiddleware,
        themeKeyMiddleware,
      );
    },
    enhancers: [sentryReduxEnhancer],
  });
};

const authStore = createStore({
  authName: "_auth",
  authType: "cookie",
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === "https:",
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<ReturnType<typeof getStore>["getState"]>;
export type AppDispatch = ReturnType<typeof getStore>["dispatch"];

export { authStore, getStore };
